import httpClient from '@/lib/httpClient.js'
import useAuthStore from '@/store/useAuthStore.js'
import { handleFormError } from '@/utils/helpers.js'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

export default function useLogin(setError) {
  const authenticate = useAuthStore((state) => state.authenticate)
  const setShowTwoFactorChallenge = useAuthStore(
    (state) => state.setShowTwoFactorChallenge,
  )
  const navigate = useNavigate()

  const action = async ({
    email = null,
    password = null,
    platform = null,
    accessToken = null,
    checkVerification = true,
  }) => {
    await httpClient.get('/csrf-cookie')

    try {
      // use fetch to get the user
      const userResponse = await fetch(
        `${import.meta.env.VITE_API_URL}/api/user`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'include',
        },
      )
      const userData = await userResponse.json()

      if (userData?.id) {
        await httpClient.post('auth/logout')
      }
    } catch (error) {
      console.log('Logout silently', error)
    }

    let response = null
    if (platform) {
      response = await httpClient.post(
        `/auth/social/sign-in`,
        {
          access_token: accessToken,
        },
        {
          params: {
            platform,
          },
        },
      )
    } else {
      response = await httpClient.post('auth/login', {
        email,
        password,
      })
    }

    if (
      checkVerification &&
      response.data?.is_verified !== undefined &&
      response.data?.is_verified === false
    ) {
      navigate('/verify-email?login=success')
      toast.error('Your email is not verified.')
      throw Error('Not verified')
    }

    if (response.data?.two_factor) {
      setShowTwoFactorChallenge(true)
      return response
    }

    authenticate(true)

    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({ error, variables, setError }),
  })

  return {
    login: mutation.mutateAsync,
    loginStatus: mutation,
  }
  //   return useQuery({ queryKey: ['login'], queryFn: action })
}
